import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Noise } from "@/components/Noise";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Works } from "@/components/Works";
import { Services } from "@/components/Services";
import { Risks } from "@/components/Risks";
import { Zone } from "@/components/Zone";
import { Booking } from "@/components/Booking";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { CallButton } from "@/components/CallButton";
import MentionsLegales from "@/components/MentionsLegales";
import Admin from "@/components/Admin";

const Home = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Works />
      <Services />
      <Risks />
      <Zone />
      <Booking />
      <Contact />
    </main>
    <Footer />
    <CallButton />
  </>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-obsidian text-bone min-h-screen" data-testid="app-root">
      <Noise />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
